import React, {Component} from 'react';
import MDSpinner from "react-md-spinner";
import './GetScholarships.css';

var JsonFileDiv = document.createElement("DIV");
JsonFileDiv.setAttribute("id", "JsonFile");
document.getElementsByTagName('body')[0].appendChild(JsonFileDiv);

let pssParams = window.pss_params;
let apiURL = document.location.host;
//let apiURL = 'localhost/wordpress';

let presales_site_url = "DEMOS-S-OED";
let presales_site_master = 'DEMO_NSW';
let presales_site_compliance = 'DEMO_NSW';
let presales_site_request = 'DEMO_NSW';
let presales_site_asset_register = 'ASSET';

if (pssParams) {
    presales_site_url = pssParams.presales_site_url;
    presales_site_master = pssParams.presales_site_master;
    presales_site_compliance = pssParams.presales_site_compliance;
    presales_site_request = pssParams.presales_site_request;
    presales_site_asset_register = pssParams.presales_site_asset_register;
}

let GetScholarshipsURL = `https://${apiURL}/wp-json/presalessettings/v1/fetchScholarships`;
let scholarshipApply = `https://${presales_site_url}.t1cloud.com/T1Default/CiAnywhere/Web/${presales_site_url.toUpperCase()}/StudentCore/StudentApplicationRegistrationMyMaintenance?f=$SC.STUAPPREG.MNT&suite=SM&ScholarshipCode=`;
class GetScholarships extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Loading: false,
            error: null,
            scholarshipList: [],
        }
    }

    componentDidMount () {
        this.setState({Loading: true});
        this._getScholarshipData();
    }

    applicationDisplay(appJson) {
        // use this line to display the Json we got back for testing / verification
        if (appJson !== '') {
            document.getElementById("JsonFile").innerHTML = "<pre>" + JSON.stringify(appJson, 0, 4) + "</pre>";
        } else {
            document.getElementById("JsonFile").innerHTML = "<pre></pre>";
        }
    }

    render () {
        const {Loading, error} = this.state;

        if (error) {
            return <div>{error.message}</div>;
        }
        
        if (Loading) {
            return <div className="MDloading"><MDSpinner size={75} /></div>;
        }

        return (
            <div>
                {this._renderMenu(this.state.scholarshipList)}
            </div>
        );
    }

    _renderMenu(scholarshipItems) {
        return (
        <div className='scholarshipList'>
            {scholarshipItems.map(([key, scholarshipButton, scholarshipTitle, applicationDateStart, applicationDateEnd, scholarshipPlaces, scholarshipAmount, scholarshipDescription]) => 
                <div className='scholarshipCard' key={key}>
                    <div className='scholarshipDescription'><span className='scholarshipspan'>{scholarshipTitle}</span><div className='scholarshipButtons'><a className='scholarshipbutton' href={scholarshipButton} target="_">Apply Now</a></div></div>
                    <div className='scholarshipDates'><span className='scholarshipspan'><div className="scholarshipOpenDate"><strong>Applications Open:&nbsp;&nbsp;</strong>{applicationDateStart}</div><div className="scholarshipCloseDate"><strong>Applications Close:&nbsp;&nbsp;</strong>{applicationDateEnd}</div></span></div>
                    <div className='scholarshipPlaces'><span className='scholarshipspan'><strong>Places Available:</strong> {scholarshipPlaces}</span></div>
                    <div className='scholarshipAmount'><span className='scholarshipspan'><strong>Standard Offer:</strong> {scholarshipAmount}</span></div>
                    <div className='scholarshipLongDescription'><span className='scholarshipLongDescriptionSpan'>{scholarshipDescription}</span></div>
                </div>
            )};
        </div>
    )};

    async _getScholarshipData() {
        await fetch(GetScholarshipsURL).then(async response => {
            let contentType = response.headers.get("Content-Type");
            if (contentType && contentType.includes("application/json")) {
                return await response.json();
            }
            throw new TypeError("Oops, we haven't got JSON!");
        }).then(json => {
            let scholarshipJSON = JSON.stringify(json, ['DataSet', 'SCHOLARSHIPCODE', 'OFFERING_NAME', 'OFFERING_DESC', 'EAPPLICATION_START_DATEI', 'EAPPLICATION_END_DATEI', 'BESTOWAL_QUOTA', 'PER_OFFER_AMT'],4);
            let scholarshipParsedJSON = JSON.parse(scholarshipJSON);
            let unorderedList = [];

            let counter = 0;
            const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

            Object.keys(scholarshipParsedJSON).forEach((key) => {
                Object.keys(scholarshipParsedJSON[key]).map((keys) => {
                        let scholarshipTitle = scholarshipParsedJSON[key][keys].SCHOLARSHIPCODE + ' - ' + scholarshipParsedJSON[key][keys].OFFERING_NAME;
                        let scholarshipButton = scholarshipApply + scholarshipParsedJSON[key][keys].SCHOLARSHIPCODE;
                        var startDateParts = scholarshipParsedJSON[key][keys].EAPPLICATION_START_DATEI.split('-');
                        var applicationDateStart = new Date(startDateParts[0], startDateParts[1] - 1, startDateParts[2]).toLocaleDateString('en-AU', dateOptions); 
                        var endDateParts = scholarshipParsedJSON[key][keys].EAPPLICATION_END_DATEI.split('-');
                        var applicationDateEnd = new Date(endDateParts[0], endDateParts[1] - 1, endDateParts[2]).toLocaleDateString('en-AU', dateOptions); 
                        let scholarshipPlaces = scholarshipParsedJSON[key][keys].BESTOWAL_QUOTA;
                        var scholarshipAmount = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', minimumFractionDigits: 2, }).format(scholarshipParsedJSON[key][keys].PER_OFFER_AMT)
                        let scholarshipDescription = scholarshipParsedJSON[key][keys].OFFERING_DESC;
                        unorderedList.push([counter++, scholarshipButton, scholarshipTitle, applicationDateStart, applicationDateEnd, scholarshipPlaces, scholarshipAmount, scholarshipDescription]);
                    /* } */
                });
            });

            //sort by toplevel name
            unorderedList.sort(function(a, b){
                if(a.title < b.title) { return -1; }
                if(a.title > b.title) { return 1; }
                return 0;
            });

            //this.applicationDisplay(json);
            this.setState({
                Loading: false,
                scholarshipList: unorderedList,
            });
        }).catch(error => this.setState({error, Loading: false}));
            return;
        }
}

export default GetScholarships;